'use strict';
const angular = require('angular');

module.exports = angular
  .module('app.core-components-implementation', [
    require('./context-menu').name,
    require('./file-viewer').name,
    require('./modals').name,
    require('./popover').name,
    require('./popup').name,
  ]);



// WEBPACK FOOTER //
// ./src/js/core-components-implementation/index.js